export default "__VITE_ASSET__81e24862__"